import { ClientMsgKind } from '@infiltre/shared';
import { selectRoom } from '@/entities/room';
import { ClochardGuess } from '@/features/game-round';
import { useGameStore, useSessionStore } from '@/shared/hooks/use-shallow-store';
import { useT } from '@/shared/lib/i18n';

/**
 * Online Clochard guess. Only the eliminated Clochard sees the input form;
 * everyone else sees a spectating message.
 */
export const OnlineClochardGuessOrchestrator = () => {
  const t = useT();
  const room = useGameStore(selectRoom);
  const driver = useSessionStore((s) => s.driver);
  const identity = useSessionStore((s) => s.identity);

  if (!room || !driver || !identity) return null;
  const clochard = room.players.find((p) => p.id === room.eliminatedThisRound);
  if (!clochard) return null;

  if (clochard.id !== identity.playerId) {
    return (
      <main
        className="relative flex h-full w-full flex-col items-center justify-center gap-6 overflow-hidden p-7 text-cream"
        style={{
          background:
            'radial-gradient(circle at 50% 35%, rgba(255,210,63,.32), transparent 55%), var(--color-ink)',
        }}
      >
        <div className="eyebrow text-pop tracking-[0.22em]">
          {t('play.clochard.spotlight').toUpperCase()}
        </div>
        <div
          className="flex h-[120px] w-[120px] animate-pulse items-center justify-center rounded-full border-[3px] border-ink font-display font-extrabold text-[56px] text-ink"
          style={{
            background: 'var(--color-white-gold)',
            filter: 'drop-shadow(0 0 28px rgba(255,210,63,.55))',
          }}
        >
          ?
        </div>
        <div className="text-center font-display font-extrabold text-[24px] leading-[1.1]">
          {t('online.clochard.spectating', { name: clochard.name })}
        </div>
      </main>
    );
  }

  return (
    <ClochardGuess
      playerName={clochard.name}
      onGuess={(guess) => {
        driver.send({ kind: ClientMsgKind.ClochardGuess, actorPlayerId: clochard.id, guess });
      }}
    />
  );
};
